import { render, staticRenderFns } from "./entity-table.vue?vue&type=template&id=a50f4f80&"
import script from "./entity-table.vue?vue&type=script&lang=js&"
export * from "./entity-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports